import { getToken } from '@mos-utils/acs';

export default function (url: string, data) {
  return fetch(url, data)
    .then((response) => {
      if (response.status !== 401) return Promise.resolve(response);
      return getToken().then((authorized) => {
        if (!authorized) return Promise.resolve(response);
        return fetch(url, data);
      });
    })
    .catch((error) => Promise.reject(error));
}
